// The one rule for a sign-in return-to path (?next=), shared by the
// server (which stores it on the sign-in link) and /app (which follows
// it after a password sign-in). Only paths back into the app pass, so
// ?next= can never bounce a freshly signed-in user to another site.

const NEXT_ALLOWED = [/^\/app(\/|$|\?)/, /^\/api\/shares\/accept\?/];

export function safeNextPath(value) {
  if (typeof value !== 'string') return null;
  const path = value.trim();
  if (!path || path.length > 512) return null;
  if (!path.startsWith('/') || path.startsWith('//') || /[\\\s]/.test(path)) return null;
  return NEXT_ALLOWED.some((re) => re.test(path)) ? path : null;
}
